import React from 'react'
import nl2br from 'react-nl2br'
import Linkify from 'react-linkify'
import axios from 'axios'
import qs from 'qs'
import { LoadMore } from 'react-weui'
import { TimeStream, filterHTML, replaceNewHost, getAccessToken } from '../utils'
import '../css/page/MessageChatPage.css'
import { Page } from '../components'


class MessageChatPage extends React.Component {
    constructor (props) {
        super(props)
        this.receiverId = +atob(props.params.receiverId)
        this.lectureId = props.location.query.lecture_id || null
        this.discussId = props.location.query.discuss_id || null
        console.log(props)
        this.state = {
            msgs: null,
            sendValue: '',
            isSendPending: false,
            nextStartTime: '',
            nickname: '',
        }
    }
    componentDidMount () {
        document.title = '对话'
        this.fetchMsgs().then(res => this.scrollIntoView())
        this.timer = setInterval(() => {
            this.fetchMsgs()
        }, 5000)
        document.removeEventListener('focusout', window.iosscrollTo);
    }
    componentWillUnmount () {
        clearInterval(this.timer)
        document.addEventListener('focusout', window.iosscrollTo);
    }
    fetchMsgs () {
        const receiverId = this.receiverId
        return axios.get(`/api/messages/chat/${receiverId}/list`, {
            params: {
                offset: this.state.nextStartTime,
                receiver_id: receiverId,
            }
        })
            .then(res => {
                this.setState({
                    msgs: (this.state.msgs || []).concat(res.data.data.messages),
                    nextStartTime: res.data.data.next_offset,
                    nickname: res.data.data.receiver.nickname,
                })
            })
    }
    scrollIntoView (delayTime = 300) {
        setTimeout(() => {
            let elem = document.getElementById("chat_footer")
            if (elem) {
                elem.scrollIntoView({
                    behavior: 'smooth'
                })
            }
        }, delayTime)
    }
    renderTimeItem (time) {
        return (
            <div className="show-time text-center">
                <span>{TimeStream(time)}</span>
            </div>
        )
    }
    postMessage (msg) {
        this.setState({ isSendPending: true })
        // if (this.lectureId) {
        // } else {
        // }

        const promise
            = (this.lectureId && this.discussId)
            ? axios.post(`/api/lecture/${this.lectureId}/discuss/${this.discussId}/private_reply`,
                qs.stringify({ msg_type: 'text', content: msg, receiver_id: this.receiverId}))
            : axios.post(`/api/messages/chat`,
                qs.stringify({ msg_type: 'text', content: msg, receiver_id: this.receiverId }))

            promise.then(res => {
                this.setState({
                    isSendPending: false,
                })
                if (res.data.code) {
                    return window._wk_toast.show(res.data.msg, '', 2000)
                }
                if (this.lectureId && this.discussId) {
                    this.fetchMsgs().then(() => this.scrollIntoView())
                    this.setState({ sendValue: '' })
                } else {
                    this.setState({
                        sendValue: '',
                        msgs: (this.state.msgs || []).concat(res.data.data.messages[0]),
                        nextStartTime: res.data.data.messages[0].create_timestamp,
                    })
                    this.scrollIntoView()
                }
            })
    }
    renderMySelfItem (item) {
        let isFlag = item.content.indexOf('qlchat') === -1 && item.content.indexOf('qianliao') === -1 && item.content.indexOf('xiaoe') === -1
        return (
            <div key={item.message_id}>
                {this.renderTimeItem(item.create_timestamp)}
                <div className="weui-flex msg-item text-right msg-mine">
                    <div className="weui-flex__item flex_10">
                        <div className="msg-cnt">
                            <div className="msg-dec msg-txt msg-txt-mine">
                                {isFlag ?
                                <Linkify properties={{target: "_blank"}}>{nl2br(replaceNewHost(item.content))}</Linkify>
                                :
                                <pre className="text-minor text-justify" dangerouslySetInnerHTML={{__html: filterHTML(replaceNewHost(item.content))}}/>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="weui-flex__item flex_2 text-center">
                        <div className="portrait"><img src={item.avatar} /></div>
                    </div>
                </div>
            </div>
        )
    }
    renderOtherItem (item) {
        let isFlag = item.content.indexOf('qlchat') === -1 && item.content.indexOf('qianliao') === -1 && item.content.indexOf('xiaoe') === -1
        return (
            <div key={item.message_id}>
                {this.renderTimeItem(item.create_timestamp)}
                <div className="weui-flex msg-item msg-opposite">
                    <div className="weui-flex__item flex_2 text-center">
                        <div className="portrait"><img src={item.avatar} /></div>
                    </div>
                    <div className="weui-flex__item flex_10">
                        <div className="msg-cnt">
                            <div className="msg-dec msg-txt">
                                {isFlag ?
                                 <Linkify properties={{target: "_blank"}}>{nl2br(replaceNewHost(item.content))}</Linkify>
                                 :
                                 <pre className="text-minor text-justify" dangerouslySetInnerHTML={{__html: filterHTML(replaceNewHost(item.content))}}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    renderMsgs (list) {
        if (!list) return <LoadMore loading></LoadMore>
        return list.map(item => {
            if (this.receiverId === item.sender_id) {
                return this.renderOtherItem(item)
            } else {
                return this.renderMySelfItem(item)
            }
        })
    }
    handleSubmitSend (e) {
        e.preventDefault()
        const msg = this.state.sendValue
        if (msg === '') return
        if (msg.length > 1000) return alert('不能超过1000个字')
        this.postMessage(msg)
    }
    getTotalHeight () {
        return document.documentElement.clientHeight + (document.body.scrollTop || document.documentElement.scrollTop)
    }
    // 兼容ios fixed定位的bug
    handleFocusInput () {
        if (window.systemType === 'ios') {
            setTimeout(() => {
                window.scrollTo(0, this.getTotalHeight() + 1000)
            }, 500)
        }
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page message-chat-page">
                    <div className="nav-bar nav-bar-fixed">
                        <p className="text-ellipsis">
                            <span className="big-font">{this.state.nickname}</span>
                        </p>
                    </div>

                    <div className="chat-list">
                        { this.renderMsgs(this.state.msgs) }
                        <div id="chat_footer"></div>
                    </div>

                    <div className="operation">
                        <div className="word-wrap" id="word_control_box">
                            <form onSubmit={(e) => this.handleSubmitSend(e)} className="weui-flex">
                                <div className="weui-flex__item flex_9" style={{paddingRight: '10px'}}>
                                    <label>
                                        <input
                                            onFocus={e => this.handleFocusInput()}
                                            type="text"
                                            placeholder="输入文字内容，1000字内"
                                            value={this.state.sendValue}
                                            onChange={e => this.setState({ sendValue: e.target.value })}
                                            disabled={this.state.isSendPending}
                                        />
                                    </label>
                                </div>
                                <div className="weui-flex__item flex_3">
                                    <button
                                        type="submit"
                                        className="weui-btn weui-btn_primary weui-btn_min btn-send"
                                        disabled={this.state.isSendPending}
                                    >
                                        { this.state.isSendPending ? '发送中' : '发送' }
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Page>
        )
    }
}


export default MessageChatPage



// WEBPACK FOOTER //
// ./src/pages/MessageChatPage.js